import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import MyDocument from './cvTemplate1';
import BlackEagle from './BlackEagle';
import BlueShark from './BlueShark';
import BlueTalent from './BlueTalent';
import SamCv from './SamCv';
import Designer from './Designer';
import BlackShark from './BlackShark';
import { useSelector } from 'react-redux';

import font from "./font/poppins-v20-latin-600.ttf";
import font1 from "./font/poppins-v20-latin-300.ttf";

Font.register({ family: 'Poppins', src: font1});
Font.register({ family: 'Poppins-bold', src: font});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  download: {
    fontFamily: "poppins",
    fontSize: "1em",
    padding: "6px 12px",
    backgroundColor: "#5843BD",
    color: "white",
    borderRadius: 10,

  }
});

const MyDoc = ({details, id}) => {
  console.log("Mydoc id and details", details)
  console.log("Mydoc id ", id)
  if (details.pdfId == "1" || id == "1") {
    return (
      <MyDocument details={details} />
    )
  } else if (details.pdfId == "2" || id == "2") {
    return (
      <BlackEagle details={details} />
    )
  } else if (details.pdfId == "3" || id == "3") {
    return (
      <BlueShark details={details} />
    )
  } else if (details.pdfId == "4" || id == "4") {
    return (
      <BlackShark details={details} />
    )
  } else if (details.pdfId == "5" || id == "5") {
    return (
      <BlueTalent details={details} />
    )
  } else if (details.pdfId == "6" || id == "6") {
    return (
      <SamCv details={details} />
    )
  } else if (details.pdfId == "7" || id == "7") {
    return (
      <Designer details={details} />
    )
  }
}

function App1(props) {
  const cv_id = useSelector(prev => prev.cvId);
  console.log("App1 details", props.details);
  console.log("APP1 id", props.id)
  return (
    <div className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex lg:flex sm:max-w-[200px] w-full" onClick={props.onClick}>
      <PDFDownloadLink document={<MyDoc details={props.details} id={props.id}/>} fileName={`${props.details.Fullname}.pdf`} >
      {({ blob, url, loading, error }) => (loading ? <Text style={{color: "white"}}>'Loading document...'</Text > : 
      <Text style={{color: "white", display:"flex"}}>{props.text}</Text>)}
    </PDFDownloadLink>
    </div>
  );
}

export default App1;
